import { ChangeDetectionStrategy, Component, computed, input, signal, WritableSignal } from '@angular/core';
import { FaqItem } from '../../models';
import { NgClass } from '@angular/common';
import { MatAccordion, MatExpansionModule } from '@angular/material/expansion';
import { CookiePreferences, StripEmbedPipe } from '@teamfoster/sdk/cookie-ngrx';
import { ResizeHtmlImagesPipe } from '@teamfoster/sdk/image';
import { SafePipe } from '@teamfoster/sdk/text-utility';

@Component({
    selector: 'app-faq-section',
    imports: [StripEmbedPipe, ResizeHtmlImagesPipe, SafePipe, MatAccordion, MatExpansionModule, NgClass],
    templateUrl: './faq-section.component.html',
    styleUrl: './faq-section.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FaqSectionComponent {
  title = input<string>();
  group = input<{ [key: string]: FaqItem[] }>({});
  cookiePreferences = input<CookiePreferences>();

  isGrid$ = computed(() => {
    return this.getKeys(this.group()).length > 2;
  });

  openPanels: WritableSignal<any> = signal(() => {
    return Object.keys(this.group()).map(key => {
      return { [key]: null };
    });
  });

  getKeys(obj: { [key: string]: any }) {
    return Object.keys(obj);
  }

  openItem(key: string, index: number) {
    this.openPanels.update(state => ({ ...state, [key]: index }));
  }
}
